// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1XJJW","detailsBorder":"styles_detailsBorder__39dgH"};